// extracted by mini-css-extract-plugin
export default {"root":"CallLabel_root__RiS2Q","icon":"CallLabel_icon__-anZ6"};